var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 6.47485,
    cy: 6,
    r: 6,
    fill: "#E62E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1121 11.6435C14.3496 11.3185 15.3464 10.6279 16.1027 9.57166C16.8589 8.51541 17.2371 7.32478 17.2371 5.99978C17.2371 4.67478 16.8589 3.48416 16.1027 2.42791C15.3464 1.37166 14.3496 0.681031 13.1121 0.356031C12.9371 0.306031 12.7871 0.334156 12.6621 0.440406C12.5371 0.546656 12.4746 0.693531 12.4746 0.881031C12.4746 0.993531 12.5152 1.09978 12.5964 1.19978C12.6777 1.29978 12.7746 1.36853 12.8871 1.40603C13.8621 1.69353 14.6433 2.26541 15.2308 3.12166C15.8183 3.97791 16.1121 4.93728 16.1121 5.99978C16.1121 7.06228 15.8183 8.02166 15.2308 8.87791C14.6433 9.73416 13.8621 10.306 12.8871 10.5935C12.7746 10.631 12.6777 10.6967 12.5964 10.7904C12.5152 10.8842 12.4746 10.9935 12.4746 11.1185C12.4746 11.306 12.5371 11.4529 12.6621 11.5592C12.7871 11.6654 12.9371 11.6935 13.1121 11.6435Z",
    fill: "#E62E2E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.875 11.6435C19.1125 11.3185 20.1094 10.6279 20.8656 9.57166C21.6219 8.51541 22 7.32478 22 5.99978C22 4.67478 21.6219 3.48416 20.8656 2.42791C20.1094 1.37166 19.1125 0.681031 17.875 0.356031C17.7 0.306031 17.55 0.334156 17.425 0.440406C17.3 0.546656 17.2375 0.693531 17.2375 0.881031C17.2375 0.993531 17.2781 1.09978 17.3594 1.19978C17.4406 1.29978 17.5375 1.36853 17.65 1.40603C18.625 1.69353 19.4062 2.26541 19.9938 3.12166C20.5813 3.97791 20.875 4.93728 20.875 5.99978C20.875 7.06228 20.5813 8.02166 19.9938 8.87791C19.4062 9.73416 18.625 10.306 17.65 10.5935C17.5375 10.631 17.4406 10.6967 17.3594 10.7904C17.2781 10.8842 17.2375 10.9935 17.2375 11.1185C17.2375 11.306 17.3 11.4529 17.425 11.5592C17.55 11.6654 17.7 11.6935 17.875 11.6435Z",
    fill: "#E62E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHight);
export default __webpack_public_path__ + "static/media/hight.d7eb32e966b292d3e036dcaeb14fb844.svg";
export { ForwardRef as ReactComponent };